/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useEffect } from 'react';
import { pkg } from '../../../settings';
import { removeCellSelections } from '../utils/removeCellSelections'; // Click outside useEffect for spreadsheet

export var useSpreadsheetOutsideClick = function useSpreadsheetOutsideClick(_ref) {
  var spreadsheetRef = _ref.spreadsheetRef,
      _ref$blockClass = _ref.blockClass,
      blockClass = _ref$blockClass === void 0 ? "".concat(pkg.prefix, "--data-spreadsheet") : _ref$blockClass,
      setActiveCellCoordinates = _ref.setActiveCellCoordinates,
      setSelectionAreas = _ref.setSelectionAreas,
      removeActiveCell = _ref.removeActiveCell,
      setContainerHasFocus = _ref.setContainerHasFocus,
      removeCellEditor = _ref.removeCellEditor;
  useEffect(function () {
    var handleOutsideClick = function handleOutsideClick(event) {
      if (!spreadsheetRef.current || spreadsheetRef.current.contains(event.target) || event.target.classList.contains("".concat(blockClass, "__active-cell--highlight")) || event.target.classList.contains("".concat(blockClass, "--interactive-cell-element"))) {
        return;
      }

      setActiveCellCoordinates(null);
      setSelectionAreas([]);
      removeActiveCell();
      removeCellSelections({
        spreadsheetRef: spreadsheetRef
      });
      setContainerHasFocus(false);
      removeCellEditor();
    };

    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [spreadsheetRef, removeActiveCell, blockClass, setActiveCellCoordinates, setContainerHasFocus, setSelectionAreas, removeCellEditor]);
};